export default class Checkout {

    constructor() {
        this.registerElements()
        this.bindEvents()
        this.checkEmail()
        this.showSaveBtn()
        const self = this
    }

    /**
     * Register DOM elements
     */
    registerElements() {
        this.email = $('#client-email')
        this.altDelivery = $('#alt_delivery')
        this.timer = ''
        this.btnShowNaw = $('.btn-show-naw')
        this.btnShowNewCustomer = $('#btn-order-new')
        this.btnShowReturningCustomer = $('#btn-order-returning')
        this.btnGoBack = $('#btn-goback')
        let orderPath = localStorage.getItem('orderPath')
        if(orderPath){
            if(orderPath === 'newCustomer'){
                $('#btn-goback').show();
                $('#column-new').show();
                $('.mobile-nav').hide();
            }
            else if(orderPath === 'returningCustomer') {
                $('#btn-goback').show();
                $('#column-returning').show();
                $('.mobile-nav').hide();
            }
        }
    }

    /**
     * Binds events to DOM elements
     */
    bindEvents() {
        $('#checkout-login').validate()
        if ($('#alt_delivery').is(':checked')) {
            $('.alt').show()
        }
        $('#naw').validate({
            rules: {
                password: {
                    minlength: 5
                },
                password_confirmation: {
                    minlength: 5,
                    equalTo: "#password"
                }
            },
            errorPlacement: function (error, element) {
                error.appendTo(element.closest(".col"))
            }
        })
        this.btnShowNaw.on("click",  function (e) {
            e.preventDefault()
            $('.naw-form').show()
            $('.naw-details').hide()
            this.showSaveBtn()

        }.bind(this))
        //
        // $(document).on("click", '.btn-pay', function (e) {
        //     if ($(this).hasClass('disabled')) {
        //         e.preventDefault()
        //     }
        // })
        //
        // $(document).on("click", '#conditions', function () {
        //     if ($('#conditions-error').length > 0 && !$('#conditions-error').is(':visible')) {
        //         $('#conditions-error').remove()
        //     }
        // })
        //
        // $(".btn-vwd").on('click', function (e) {
        //     e.preventDefault()
        //     e.stopPropagation()
        //     $(".vwd").toggle()
        //     $('html, body').animate({scrollTop: $('.vwd h2').position().top + 350})
        // })


        this.altDelivery.on('click', function () {
            setTimeout(function(){
                if($('.alt').is(":visible") && !$('.naw-form').is(":visible")) {
                    document.location = '/removeAltAddress/'+$('#country').val()+'/'
                }
                else {
                    $('.alt').toggle()
                    this.showSaveBtn()
                }
            }.bind(this),300)

        }.bind(this))


        // $('#payment_method_ideal').on('click', function () {
        //     $('.choose-ideal').slideDown()
        // })
        //
        // $('#payment_method_creditcard').on('click', function () {
        //     $('.choose-ideal').slideUp()
        // })

        this.email.on('keyup', function () {
            clearTimeout(this.timer)
            this.timer = setTimeout(function () {
                if($('#client-email').indexOf('@') > 0 && $('#client-email').indexOf('.') > 0) {
                    $('#client-email').blur()
                }
            }, 800)
        })
        this.email.on('blur', function () {
            this.checkEmail()
        }.bind(this))

        this.btnShowNewCustomer.on('click', function() {
            $('#btn-goback').show();
            $('#column-new').show();
            $('.mobile-nav').hide();
            localStorage.setItem('orderPath', 'newCustomer')
        })
        this.btnShowReturningCustomer.on('click', function() {
            $('#btn-goback').show();
            $('#column-returning').show();
            $('.mobile-nav').hide();
            localStorage.setItem('orderPath', 'returningCustomer')
        })
        this.btnGoBack.on('click', function() {
            $('#btn-goback').hide();
            $('#column-returning').hide();
            $('#column-new').hide();
            $('.mobile-nav').show();
            localStorage.removeItem('orderPath')
        })
    }

    showSaveBtn(){
        if($('.alt').is(':visible') || $('.naw-form').is(':visible') ) {
            $('.btn_form_alt').show()
        }
        else {
            $('.btn_form_alt').hide()
        }
    }

    checkEmail() {
        $.post("/cart/check-email/", {email: this.email.val()}, function (data) {
            if(data == 'exists') {
                $('#accountExists').show()
                $('#createAccount').hide()
                $('.btn-save-profile').hide()
            }
            else {
                $('#accountExists').hide()
                $('#createAccount').show()
                $('.btn-save-profile').show()
            }
        })
    }

}


